export default __webpack_public_path__ + "static/media/a6.64f9f643.png";